// frontend/src/components/historias/EspecialidadTabContent.jsx - VERSIÃ“N CORREGIDA SIN RECURSIÃ“N
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Box, Typography, Tabs, Tab, Paper, Grid, Button, Chip,
  Alert, CircularProgress, LinearProgress, useTheme, useMediaQuery,
  Accordion, AccordionSummary, AccordionDetails, Stack, Card, CardContent,
  IconButton, Collapse, Drawer, AppBar, Toolbar
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  CheckCircle as CheckCircleIcon,
  RadioButtonUnchecked as RadioButtonUncheckedIcon,
  PlayArrow as PlayArrowIcon,
  Assignment as AssignmentIcon,
  Description as DescriptionIcon,
  Timeline as TimelineIcon,
  Menu as MenuIcon,
  Close as CloseIcon, 
  Lock as LockIcon,
  LockOpen as LockOpenIcon,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { useNotification } from '../../contexts/NotificationContext';
import { useAuth } from '../../hooks/useAuth';
import etapaTratamientoService from '../../services/etapaTratamientoService';
import FormulariosDinamicos from './FormulariosDinamicos';
import DocumentosEspecialidadList from '../documentos/DocumentosEspecialidadList';
 
import { formatDate } from '../../utils/dateUtils';
import Swal from 'sweetalert2';
 
// Componentes estilizados responsivos
const ResponsiveContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(1),
  },
}));

const MobileTabsContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(2),
  },
}));

const ResponsiveTabs = styled(Tabs)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
    height: 3,
  },
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.875rem',
    minHeight: 48,
    padding: theme.spacing(1, 2),
    [theme.breakpoints.down('md')]: {
      fontSize: '0.75rem',
      minWidth: 'auto',
      padding: theme.spacing(1, 1.5),
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7rem',
      padding: theme.spacing(1),
      minWidth: 80,
    },
    '&.Mui-selected': {
      color: theme.palette.primary.main,
      fontWeight: 700,
    }
  },
  [theme.breakpoints.down('sm')]: {
    '& .MuiTabs-scrollButtons': {
      width: 32,
    },
  },
}));

const MobileCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(0, 1, 2, 1),
    borderRadius: theme.spacing(2),
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(0, 0.5, 1.5, 0.5),
    borderRadius: theme.spacing(1.5),
  },
}));

const ProgressCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  borderRadius: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(1.5),
    margin: theme.spacing(0, 1, 2, 1),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    margin: theme.spacing(0, 0.5, 1.5, 0.5),
  },
}));

const MobileAccordion = styled(Accordion)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  borderRadius: '12px !important',
  overflow: 'hidden',
  '&:before': { display: 'none' },
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(0, 1, 1, 1),
    borderRadius: '8px !important',
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(0, 0.5, 1, 0.5),
    borderRadius: '6px !important',
  },
}));

const EspecialidadTabContent = ({ 
  seccionEspecialidad, 
  historiaUnificadaId, 
  pacienteId,
  onUpdate 
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { showNotification } = useNotification();
  const { user } = useAuth();
  
  // Estados
  const [loading, setLoading] = useState(true);
  const [etapas, setEtapas] = useState([]);
  const [etapaSeleccionada, setEtapaSeleccionada] = useState(0);
  const [error, setError] = useState(null);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [estadosEtapas, setEstadosEtapas] = useState({});
  const [procesandoEstado, setProcesandoEstado] = useState({});

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parentRespuestaId = searchParams.get('parent');

  // Memoizar IDs para evitar re-renders innecesarios
  const especialidadId = useMemo(() => seccionEspecialidad?.especialidad_id, [seccionEspecialidad?.especialidad_id]);
  const programaId = useMemo(() => seccionEspecialidad?.programa_id, [seccionEspecialidad?.programa_id]);
  const historiaEspecialidadId = useMemo(() => seccionEspecialidad?.id, [seccionEspecialidad?.id]);

  // IMPORTANTE: Definir funciones con useCallback ANTES de usarlas
   

  const cargarEtapas = useCallback(async () => {
  // ðŸ”¥ DOBLE VERIFICACIÃ“N DE BLOQUEO
  if (window.sistemaBloqueoRecargas?.estaBloqueado()) {
     return;
  }
  
  if (!especialidadId) {
    console.warn('No hay especialidad_id disponible');
    return;
  }
  
  try {
    setLoading(true);
    setError(null);
    
    const response = await etapaTratamientoService.getByEspecialidad(
      especialidadId,
      programaId,
      historiaEspecialidadId
    );
    
    const etapasData = response.data || [];
    setEtapas(etapasData);
    
    const estadosMap = {};
    etapasData.forEach(etapa => {
      estadosMap[etapa.id] = etapa.estado || 'abierto';
    });
    setEstadosEtapas(estadosMap);
    
    // ðŸ”¥ NO CAMBIAR ETAPA SELECCIONADA NUNCA - Solo en carga inicial
    if (etapas.length === 0) {
      if (seccionEspecialidad.etapa_actual_id) {
        const indiceEtapaActual = etapasData.findIndex(
          e => e.id === seccionEspecialidad.etapa_actual_id
        );
        if (indiceEtapaActual >= 0) {
          setEtapaSeleccionada(indiceEtapaActual);
        }
      } else if (etapasData.length > 0) {
        setEtapaSeleccionada(0);
      }
    }
           
  } catch (error) {
    console.error('Error al cargar etapas:', error);
    setError('Error al cargar las etapas de tratamiento');
    showNotification('Error al cargar las etapas', 'error');
  } finally {
    setLoading(false);
  }
}, [especialidadId, programaId, historiaEspecialidadId, showNotification]);

  // Cargar etapas de la especialidad - Solo cuando cambian las dependencias relevantes
  useEffect(() => {
  let mounted = true;
  
  const loadData = async () => {
    // ðŸ”¥ VERIFICAR BLOQUEO DEL SISTEMA
    if (window.sistemaBloqueoRecargas?.estaBloqueado()) {
       return;
    }
    
    if (mounted) {
       await cargarEtapas();
    }
  };
  
  loadData();
  
  return () => {
    mounted = false;
  };
}, [cargarEtapas]);

  // Cerrar etapa
  const cerrarEtapa = async (etapaId, etapaNombre) => {
    try {
      const confirmado = await Swal.fire({
        title: 'Â¿Cerrar etapa?',
        text: `Â¿EstÃ¡ seguro de cerrar la etapa "${etapaNombre}"? Los formularios de esta etapa quedarÃ¡n en modo solo lectura.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'SÃ­, cerrar etapa',
        cancelButtonText: 'Cancelar'
      });
      
      if (!confirmado.isConfirmed) return;
      
      setProcesandoEstado(prev => ({ ...prev, [etapaId]: true }));
      
      const response = await etapaTratamientoService.cerrarEtapa(
        historiaEspecialidadId,
        etapaId
      );
      
      if (response.success) {
        showNotification('Etapa cerrada correctamente', 'success');
        
        // Actualizar estado local
        setEstadosEtapas(prev => ({
          ...prev,
          [etapaId]: 'cerrado'
        }));
        
        // Recargar etapas
        await cargarEtapas();
      }
    } catch (error) {
      console.error('Error al cerrar etapa:', error);
      showNotification('Error al cerrar la etapa', 'error');
    } finally {
      setProcesandoEstado(prev => ({ ...prev, [etapaId]: false }));
    }
  };

  // Reabrir etapa (solo admin)
  const reabrirEtapa = async (etapaId, etapaNombre) => {
    try {
      const confirmado = await Swal.fire({
        title: 'Â¿Reabrir etapa?',
        text: `Â¿EstÃ¡ seguro de reabrir la etapa "${etapaNombre}"?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'SÃ­, reabrir',
        cancelButtonText: 'Cancelar'
      });
      
      if (!confirmado.isConfirmed) return;
      
      setProcesandoEstado(prev => ({ ...prev, [etapaId]: true }));
      
      const response = await etapaTratamientoService.reabrirEtapa(
        historiaEspecialidadId,
        etapaId
      );
      
      if (response.success) {
        showNotification('Etapa reabierta correctamente', 'success');
        
        // Actualizar estado local
        setEstadosEtapas(prev => ({
          ...prev,
          [etapaId]: 'abierto'
        }));
        
        // Recargar etapas
        await cargarEtapas();
      }
    } catch (error) {
      console.error('Error al reabrir etapa:', error);
      showNotification(error.response?.data?.message || 'Error al reabrir la etapa', 'error');
    } finally {
      setProcesandoEstado(prev => ({ ...prev, [etapaId]: false }));
    }
  };

  // Manejar cambio de etapa
  const handleEtapaChange = (event, newValue) => {
    setEtapaSeleccionada(newValue);
    if (isMobile) {
      setMobileDrawerOpen(false);
    }
  };

  // Obtener color del chip segÃºn estado
  const getEtapaColor = (etapa) => {
    const estado = estadosEtapas[etapa.id];
    return estado === 'cerrado' ? 'success' : 'default';
  };

  // Obtener icono segÃºn estado
  const getEtapaIcon = (etapa) => {
    const estado = estadosEtapas[etapa.id];
    return estado === 'cerrado' ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon />;
  };

  // Componente de navegación móvil
  const MobileEtapasDrawer = () => (
    <Drawer
      anchor="bottom"
      open={mobileDrawerOpen}
      onClose={() => setMobileDrawerOpen(false)}
      PaperProps={{
        sx: {
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          maxHeight: '80vh'
        }
      }}
    >
      <AppBar position="static" color="default" elevation={0}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Seleccionar Etapa
          </Typography>
          <IconButton 
            edge="end"
            onClick={() => setMobileDrawerOpen(false)}
            sx={{ ml: 2 }}
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      
      <Box sx={{ p: 2, overflow: 'auto' }}>
        <Stack spacing={1}>
          {etapas.map((etapa, index) => {
        
            const estado = estadosEtapas[etapa.id];
            const isSelected = index === etapaSeleccionada;
            
            return (
              <Card
                key={etapa.id}
                sx={{
                  cursor: 'pointer',
                  border: isSelected ? 2 : 1,
                  borderColor: isSelected ? 'primary.main' : 'divider',
                  bgcolor: isSelected ? 'primary.50' : 'background.paper',
                  opacity: estado === 'cerrado' ? 0.7 : 1,
                  transition: 'all 0.2s',
                  '&:hover': {
                    bgcolor: isSelected ? 'primary.50' : 'action.hover',
                    transform: 'translateX(4px)',
                  }
                }}
                onClick={() => {
                  setEtapaSeleccionada(index);
                  setMobileDrawerOpen(false);
                }}
              >
                <CardContent sx={{ py: 2 }}>
                  <Box display="flex" alignItems="center" gap={2}>
                    {getEtapaIcon(etapa)}
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="subtitle2" fontWeight="bold">
                        {etapa.nombre}
                        {estado === 'cerrado' && ' (Cerrada)'}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Estado: {estado === 'cerrado' ? 'Completada' : 'En proceso'}
                      </Typography>
                    </Box>
                    <Chip 
                      label={estado === 'cerrado' ? '100%' : '0%'}
                      size="small"
                      color={getEtapaColor(etapa)}
                    />
                  </Box>
                </CardContent>
              </Card>
            );
          })}
        </Stack>
      </Box>
    </Drawer>
  );

  // Returns condicionales tempranos
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ m: isMobile ? 1 : 2 }}>
        {error}
      </Alert>
    );
  }

  if (etapas.length === 0) {
    return (
      <Alert severity="info" sx={{ m: isMobile ? 1 : 2 }}>
        No hay etapas configuradas para esta especialidad
      </Alert>
    );
  }

  // Variables normales (no hooks) despuÃ©s de los returns
  const etapaActual = etapas[etapaSeleccionada];

  return (
    <ResponsiveContainer>
       

      {/* Navegación por etapas - Diferente para móvil */}
      {isMobile ? (
        <>
          <Box sx={{ mb: 2 }}>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => setMobileDrawerOpen(true)}
              startIcon={<MenuIcon />}
              endIcon={<Chip label={`${etapas.length} etapas`} size="small" />}
              sx={{
                py: 1.5,
                justifyContent: 'space-between',
                borderRadius: 2,
                mx: isSmallMobile ? 0.5 : 1,
              }}
            >
              <Box textAlign="left">
                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                  {etapaActual?.nombre}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  Etapa {etapaSeleccionada + 1} de {etapas.length}
                </Typography>
              </Box>
            </Button>
          </Box>
          <MobileEtapasDrawer />
        </>
      ) : (
        <Paper elevation={0} sx={{ mb: 3 }}>
          <MobileTabsContainer sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <ResponsiveTabs
              value={etapaSeleccionada}
              onChange={handleEtapaChange}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
            >
              {etapas.map((etapa, index) => {
      
                const estado = estadosEtapas[etapa.id];
                return (
                  <Tab
                    key={etapa.id}
                    disabled={false}
                    icon={getEtapaIcon(etapa)}
                    iconPosition="start"
                    label={
                      <Box>
                        <Typography variant="body2" fontWeight="medium">
                          {etapa.nombre}
                          {estado === 'cerrado' && ' (Cerrada)'}
                        </Typography>
                        <Chip 
                          label={estado === 'cerrado' ? '100%' : '0%'}
                          size="small"
                          color={getEtapaColor(etapa)}
                          sx={{ height: 16, fontSize: '0.75rem', mt: 0.5 }}
                        />
                      </Box>
                    }
                    sx={{ 
                      minHeight: isMobile ? 60 : 72,
                      opacity: estado === 'cerrado' ? 0.8 : 1,
                    }}
                  />
                );
              })}
            </ResponsiveTabs>
          </MobileTabsContainer>
        </Paper>
      )}

      {/* Contenido de la etapa seleccionada */}
      {etapaActual ? (
        <Box>
          {/* Header de la etapa - Responsive */}
          <MobileCard>
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap={1}>
                <Box>
                  <Typography variant={isMobile ? "subtitle1" : "h6"} sx={{ fontWeight: 'bold' }}>
                    {etapaActual.nombre}
                    {estadosEtapas[etapaActual.id] === 'cerrado' && (
                      <Chip 
                        label="Cerrada"
                        icon={<LockIcon />}
                        color="default"
                        size="small"
                        sx={{ ml: 1 }}
                      />
                    )}
                  </Typography>
                  {etapaActual.descripcion && (
                    <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
                      {etapaActual.descripcion}
                    </Typography>
                  )}
                </Box>
                
                <Stack direction={isMobile ? "column" : "row"} spacing={1} alignItems="flex-end">
                  {etapaActual.duracion_estimada && (
                    <Chip 
                      label={`${etapaActual.duracion_estimada} sesiones`}
                      variant="outlined"
                      size="small"
                    />
                  )}
                  
                  <Chip 
                    label={estadosEtapas[etapaActual.id] === 'cerrado' ? '100%' : '0%'}
                    color={getEtapaColor(etapaActual)}
                    size="small"
                  />
                  
                  {/* Botones de control de estado */}
                  {estadosEtapas[etapaActual.id] === 'cerrado' ? (
                    user?.rol_id === 1 && (
                      <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        startIcon={<LockOpenIcon />}
                        onClick={() => reabrirEtapa(etapaActual.id, etapaActual.nombre)}
                        disabled={procesandoEstado[etapaActual.id]}
                      >
                        Reabrir
                      </Button>
                    )
                  ) : (
                    <Button
                      size="small"
                      variant="outlined"
                      color="error"
                      startIcon={<LockIcon />}
                      onClick={() => cerrarEtapa(etapaActual.id, etapaActual.nombre)}
                      disabled={procesandoEstado[etapaActual.id]}
                    >
                      Cerrar Etapa
                    </Button>
                  )}
                </Stack>
              </Box>
            </CardContent>
          </MobileCard>

          {/* Alerta si la etapa estÃ¡ cerrada */}
          {estadosEtapas[etapaActual.id] === 'cerrado' && (
            <Alert 
              severity="info" 
              icon={<LockIcon />}
              sx={{ m: isMobile ? 1 : 2 }}
            >
              Esta etapa estÃ¡ cerrada. Todos los formularios estÃ¡n en modo solo lectura.
              {user?.rol_id === 1 && ' Solo los administradores pueden reabrir etapas cerradas.'}
            </Alert>
          )}

 
          {/* Secciones expandibles de la etapa - Responsive */}
          <Box>
            {/* Sección de Formularios */}
            <MobileAccordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                  <AssignmentIcon />
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                    Formularios
                  </Typography>
             
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ p: isMobile ? 1 : 3 }}>
                <FormulariosDinamicos
                  historiaEspecialidadId={historiaEspecialidadId}
                  etapaId={etapaActual.id}
                  pacienteId={pacienteId}
                  especialidadId={especialidadId}
                  parentRespuestaId={parentRespuestaId}
                />
              </AccordionDetails>
            </MobileAccordion>
 
            {/* Sección de Documentos */}
            <MobileAccordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                  <DescriptionIcon />
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                    Documentos de la Especialidad
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ p: isMobile ? 1 : 3 }}>
                <DocumentosEspecialidadList
                  historiaId={historiaUnificadaId}
                  especialidadId={especialidadId}
                  especialidad={seccionEspecialidad?.especialidad}
                  etapaId={etapaActual?.id}
                  pacienteId={pacienteId}
                  onDocumentoCreado={(documento) => {
                    // Opcional: manejar cuando se crea un documento
                   }}
                  onDocumentoEliminado={(documentoId) => {
                    // Opcional: manejar cuando se elimina un documento
                   }}
                />
              </AccordionDetails>
            </MobileAccordion>

          </Box>
        </Box>
      ) : (
        <Alert severity="warning" sx={{ m: isMobile ? 1 : 2 }}>
          No se pudo cargar la información de la etapa seleccionada
        </Alert>
      )}
    </ResponsiveContainer>
  );
};

export default EspecialidadTabContent;